import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { LessonDetailComponent } from '../lesson-detail/lesson-detail.component';
import { LessonService } from 'src/app/service/lesson.service';
import { InstructorService } from 'src/app/service/instructor.service';
import { Lesson } from 'src/app/model/lesson.model';
import { TimeSlot } from 'src/app/model/time-slot.model';
import { LessonType } from 'src/app/model/lesson-type.model';
import { DataService } from 'src/app/service/data.service';

@Component({
  selector: 'app-lesson-selection',
  templateUrl: './lesson-selection.component.html',
  styleUrls: ['./lesson-selection.component.css']
})
export class LessonSelectionComponent implements OnInit {

  lessons: Lesson[];
  newLesson: Lesson;

  lessonTypes: LessonType[];

  constructor(
    public dialogRef: MatDialogRef<LessonSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LessonSelectionDialogData,
    private lessonService: LessonService,
    private instructorService: InstructorService,
    private dataService: DataService
   ) { }

  ngOnInit() {
    this.instructorService.getInstructorLessons(this.data.instructorId).subscribe(data => {
      this.lessons = data as Lesson[];
    });

    this.dataService.getlessonTypes().subscribe(data=>{
      this.lessonTypes=data as LessonType[];
    })
    this.newLesson = new Lesson();
  }

  selectLesson(lesson: Lesson) {
    this.lessonService.addTimeSlot(lesson.id, this.data.timeSlot).subscribe(data => {
      if (data) {
        this.dialogRef.close(lesson);
      }
    });
  }

  createNewLesson() {
    this.newLesson.timeSlots = [];
    this.newLesson.students = [];
    this.newLesson.timeSlots.push(this.data.timeSlot);
    this.lessonService.add(this.data.instructorId, this.newLesson).subscribe(data => {
      if (data) {
        this.dialogRef.close(this.newLesson);
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

}


export interface LessonSelectionDialogData {
  instructorId: number;
  lesson: Lesson;
  timeSlot: TimeSlot;
}
